/* eslint-disable react/destructuring-assignment */
import React from "react";

const PauseConsentIcon = props => {
  const { ...restProps } = props;

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "8px",
        verticalAlign: "middle",
      }}
      {...restProps}
    >
      <path d="M10.5 0H8C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12H10.5C10.7652 12 11.0196 11.8946 11.2071 11.7071C11.3946 11.5196 11.5 11.2652 11.5 11V1C11.5 0.734784 11.3946 0.48043 11.2071 0.292893C11.0196 0.105357 10.7652 0 10.5 0ZM10.5 11H8V1H10.5V11ZM4 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V11C0.5 11.2652 0.605357 11.5196 0.792893 11.7071C0.98043 11.8946 1.23478 12 1.5 12H4C4.26522 12 4.51957 11.8946 4.70711 11.7071C4.89464 11.5196 5 11.2652 5 11V1C5 0.734784 4.89464 0.48043 4.70711 0.292893C4.51957 0.105357 4.26522 0 4 0ZM4 11H1.5V1H4V11Z" />
    </svg>
  );
};

export default PauseConsentIcon;
